"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toHex = void 0;
var toHex = function (c) {
    switch (c) {
        case 'op-orange':
            return '#FE7D49';
        case 'meno-blue':
            return '#5C72B6';
        case 'meno-cool-blue': // Introduced for MENO VM
            return '#6D99F2';
        case 'meno-light-blue': // this should be 'meno-purple'
            return '#CAB5D8';
        case 'meno-light-purple':
            return '#F3E3FE';
        case 'meno-dark-purple':
            return '#613D7A';
        case 'meno-vaginal-moisture':
            return '#82ADDC';
        case 'uro-uti-red':
            return '#C41423';
        case 'uro-vp-pink':
            return '#FF9A9D';
        case 'uro-hot-pink':
            return '#F24444';
        case 'uro-pale-pink':
            return '#F2CEC8';
        case 'uro-id-pink':
            return '#FF9A9D';
        case 'white':
            return '#FFFFFF';
        case 'preggo-blue':
            return '#174877';
        case 'preggo-2':
            return '#A8C2E5';
        case 'preggo-3':
            return '#CCE1F2';
        case 'preggo-4':
            return '#5880C0';
        case 'flo-os-pink':
            return '#EF609C';
        case 'flo-dark-pink':
            return '#F37490';
        case 'flo-pale-pink':
            return '#FCE9ED';
        case 'charcoal':
            return '#2d2926';
        case 'flo-hot-pink':
            return '#FF5764';
        case 'flo-light-pink':
            return '#FABDCC';
        case 'flo-pms-pink':
            return '#F37490';
        case 'uro-bs-red':
            return '#C32434';
        case 'gogo-red':
            return '#CE2715';
        case 'gogo-light-orange':
            return '#FE7D49';
        case 'gogo-orange':
            return '#FF7D48';
        case 'gogo-pale-orange':
            return '#FBDAC9';
        case 'willo-dark-green':
            return '#2E630C';
        case 'willo-light-green':
            return '#BDBD44';
        case 'retro-gs-light-yellow':
            return '#FAA943';
        case 'retro-gs-dark-yellow':
            return '#CE7910';
        case 'retro-acne-light-blue':
            return '#A2CAEB';
        case 'retro-acne-dark-blue':
            return '#2F5778';
        case 'moto-light-green':
            return '#079247';
        case 'moto-dark-green':
            return '#0A5E2B';
        case 'uro-pf-orange':
            return '#f0533f';
        case 'uro-pf-beige':
            return '#f2e2da';
        case 'orange':
            return '#ff561c';
        default:
            var exhaustiveCheck = c;
            console.error("Unhandled color case: ".concat(exhaustiveCheck));
            return '#2d2926';
    }
};
exports.toHex = toHex;
